import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  // Fail loudly in dev rather than silently hitting an undefined backend.
  console.error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copy web/.env.example to web/.env.local.'
  );
}

export const supabase = createClient(url ?? '', anonKey ?? '', {
  auth: {
    // Teacher sessions persist in the browser; the student check-in flow
    // never calls any auth.* method, so no session is ever created there.
    persistSession: true,
    autoRefreshToken: true,
  },
});
